import { inject, Signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { URL_QUERY_PARAM_WRITE } from './url-query-param.function';

interface MobileSidebarProvider {
  setOpenMobile(open: boolean): Promise<void>;
}

/**
 * Closes the mobile sidebar drawer on every completed navigation except a filter write, and
 * returns a `close()` for interactions that should close it without
 * navigating (e.g. a search trigger).
 *
 * Pass in a `viewChild<DmSidebarProvider>('sidebarProvider')` signal from
 * the caller's own template — `viewChild()` must be declared directly in a
 * class field initializer, so it can't live inside this function.
 */
export function injectMobileSidebarCloser(sidebarProvider: Signal<MobileSidebarProvider | undefined>): { close: () => void } {
  const router = inject(Router);

  const close = (): void => {
    void sidebarProvider()?.setOpenMobile(false);
  };

  router.events
    .pipe(
      filter((event) => event instanceof NavigationEnd),
      filter(() => router.lastSuccessfulNavigation()?.extras.info !== URL_QUERY_PARAM_WRITE),
      takeUntilDestroyed(),
    )
    .subscribe(close);

  return { close };
}
